import { Grid } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import SimpleTable from "components/Tables/SimpleTable";
import dataEquipamiento from "./dataEquipamiento";
import SinDatos from "components/Carteles/SinDatos";
import Firma from "../Firma";

const Equipamiento = ({ listadoEquipamiento }) => {
  const { columns, getRows } = dataEquipamiento;

  const memoizedRows = useMemo(() => {
    if (listadoEquipamiento) {
      const listadoSinBorrar = listadoEquipamiento.filter((item) => !item.borrado);
      return getRows(listadoSinBorrar);
    }
    return [];
  }, [listadoEquipamiento]);

  return (
    <Grid container p={2}>
      <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="flex-end">
        <SoftTypography color="black" variant="h4" fontWeight="bold">
          Equipamientos
        </SoftTypography>
      </Grid>
      <Grid item xs={12} py={1}>
        {listadoEquipamiento?.length > 0 ? (
          <SimpleTable columns={columns} rows={memoizedRows} />
        ) : (
          <SinDatos textoTitulo="No hay equipamientos cargados" />
        )}
      </Grid>
      <Firma marginTop={10} />
    </Grid>
  );
};

export default memo(Equipamiento);

Equipamiento.propTypes = {
  listadoEquipamiento: PropTypes.array.isRequired,
};
